



// import React, { useState } from "react";
// import { useNavigate } from 'react-router-dom';
// import robotics from "../img/aaaservices/robotics.jpg";

// const KeyFuturesSection = () => {

//     const navigate = useNavigate();

//     const goToEnquirySection = () =>
//         navigate('/contact#enquiry');
//     const goToHomeSection = () =>
//         navigate('/');
//     const goToCartPage = () => {
//   navigate('/cart-page');
// };
//     const [showPopup, setShowPopup] = useState(false);


//     const openPopup = () => setShowPopup(true);
//     const closePopup = () => setShowPopup(false);



//     const [formData, setFormData] = useState({
//         name: "",
//         email: "",
//         phone: "",
//         date: "",
//         gender: "",
//         message: "",
//         plan: "",
//         cources: "",
//     });

//     // const handleChange = (e) => {
//     //     const { id, value } = e.target;
//     //     setFormData((prev) => ({
//     //         ...prev,
//     //         [id]: value,
//     //     }));
//     // };

//     const handleChange = (e) => {
//         const { id, value } = e.target;
//         setFormData((prev) => ({
//             ...prev,
//             [id]: value,
//         }));
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         const apiBody = {
//             name: formData.name,
//             emailId: formData.email,
//             mobileNumber: formData.phone,
//             dateOfBirth: formData.date,
//             gender: formData.gender,
//             message: formData.message,
//             plan: formData.plan,
//             cources: formData.cources,
//         };

//         try {
//             const response = await fetch("http://iiaserver.iiautomate/IIA-Website-1.0.0/enquiry/add", {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json",
//                 },
//                 body: JSON.stringify(apiBody),
//             });

//             if (response.ok) {
//                 alert("Your details have been submitted successfully!");
//                 setFormData({
//                     name: "",
//                     email: "",
//                     phone: "",
//                     date: "",
//                     gender: "",
//                     message: "",
//                     plan: "",
//                     cources: "",
//                 });
//                 closePopup();
//             } else {
//                 alert("There was an issue submitting your details.");
//             }
//         } catch (error) {
//             alert("Something went wrong. Please try again later.");
//         }
//     };

//     const inputStyle = {
//         padding: "10px",
//         fontSize: "14px",
//         borderRadius: "5px",
//         border: "1px solid #ccc",
//         fontFamily: "Roboto",
//     };


//     return (


//         <div>
//             <div className="webinarsss" style={{ fontSize: '30px', color: 'black', fontFamily: 'Roboto', fontWeight: 'bold', margTop: '50px', textAlign: 'center', marginTop: '20px' }}>
//                 Robotics & <span style={{ color: 'blue' }}>Virtual Simulation</span>

//             </div>
//             <div className="container mt-5">
//                 <div className="row d-flex align-items-start" style={{ marginTop: "60px" }}>
//                     {/* Content Section */}
//                     <div className="col-md-7">
//                         <div className="p-4 bg-white shadow rounded mb-4 virtual-key" style={{ height: '300px', }}>
//                             <h2 style={{ fontWeight: "bold", fontSize: '22px', fontFamily: 'roboto' }}>
//                                 {" "}

//                                 <span style={{ color: 'blue' }}> 6-Axis </span> Industrial Robotic Virtual <span style={{ color: 'orange' }}> Simulation </span>{" "}
//                             </h2>
//                             <div style={{ textAlign: 'justify', fontFamily: 'roboto' }}>
//                                 <p style={{ fontFamily: 'roboto' }}>
//                                     Adoption of 6-axis industrial robots is revolutionizing sectors such as manufacturing and logistics, offering precise automation for tasks like welding and assembly. Virtual simulation allows for cost-effective testing and optimization without physical hardware, reducing risks and costs. As the demand for automation grows, and with advancements in AI and IoT, mastering robotic programming and simulation is crucial for staying ahead in this dynamic field.
//                                 </p>

//                                 <div
//                                     className="disccccreting"
//                                     style={{
//                                         display: 'flex',
//                                         alignItems: 'center',
//                                         justifyContent: 'left',
//                                         gap: '20px',
//                                         marginTop: '19px',
//                                         flexWrap: 'wrap',
//                                         // Allows wrapping in smaller screens
//                                     }}
//                                 >
//                                     {/* Rating Section */}
//                                     <div style={{ display: 'flex', alignItems: 'center', gap: '5px', flex: '1 1 auto' }}>
//                                         <span style={{ fontSize: '16px', fontWeight: 'bold' }}>4.5</span>
//                                         <div style={{ display: 'flex', fontSize: '20px', flex: '1 1 auto' }}>
//                                             <span style={{ color: '#FFD700' }}>★</span>
//                                             <span style={{ color: '#FFD700' }}>★</span>
//                                             <span style={{ color: '#FFD700' }}>★</span>
//                                             <span style={{ color: '#FFD700' }}>★</span>
//                                             <span style={{ color: '#FFD700', position: 'relative' }}>
//                                                 <span
//                                                     style={{
//                                                         color: '#fff',
//                                                         position: 'absolute',
//                                                         left: '8px',
//                                                         overflow: 'hidden',
//                                                         width: '10px',
//                                                     }}
//                                                 >
//                                                     ★
//                                                 </span>
//                                             </span>
//                                         </div>

//                                         {/* Buttons Wrapper */}
//                                         <div
//                                             style={{
//                                                 display: 'flex',
//                                                 gap: '10px',
//                                                 flex: '1 1 auto',
//                                                 justifyContent: 'flex-end',
//                                                 flexWrap: 'wrap',
//                                             }}
//                                         >
//                                             {/* Wishlist Button */}
//                                             <a
//                                                 href="/brochure.pdf" // Path to the file in the public folder
//                                                 download="brochure.pdf" // This triggers the download
//                                                 style={{
//                                                     textDecoration: 'none',
//                                                     display: 'inline-block',
//                                                 }}
//                                             >
//                                                 <button
//                                                     style={{
//                                                         padding: '10px 20px',
//                                                         fontSize: '14px',
//                                                         backgroundColor: '#007bff',
//                                                         color: 'white',
//                                                         border: '1px solid #ccc',
//                                                         borderRadius: '5px',
//                                                         fontFamily: 'roboto',
//                                                         fontWeight: 'bold',
//                                                         cursor: 'pointer',
//                                                         flex: '1 1 auto',
//                                                         minWidth: '120px',
//                                                     }}
//                                                 >
//                                                     Brochure
//                                                 </button>
//                                             </a>

//                                             {/* Enquiry Now Button */}
//                                             <button
//                                                 onClick={goToCartPage}
//                                                 style={{
//                                                     padding: '10px 20px',
//                                                     fontSize: '14px',
//                                                     backgroundColor: '#007bff',
//                                                     color: '#fff',
//                                                     border: 'none',
//                                                     borderRadius: '5px',
//                                                     fontFamily: 'roboto',
//                                                     fontWeight: 'bold',
//                                                     cursor: 'pointer',
//                                                     flex: '1 1 auto',
//                                                     minWidth: '120px',
//                                                 }}
//                                             >
//                                                 Add to Cart
//                                             </button>


//                                             <button
//                                                 onClick={goToEnquirySection}
//                                                 style={{
//                                                     padding: '10px 20px',
//                                                     fontSize: '14px',
//                                                     backgroundColor: '#007bff',
//                                                     color: '#fff',
//                                                     border: 'none',
//                                                     borderRadius: '5px',
//                                                     fontFamily: 'roboto',
//                                                     fontWeight: 'bold',
//                                                     cursor: 'pointer',
//                                                     flex: '1 1 auto',
//                                                     minWidth: '120px',
//                                                 }}
//                                             >
//                                                 Enquiry Now
//                                             </button>
//                                         </div>
//                                     </div>

//                                     {showPopup && (
//                                         <div
//                                             style={{
//                                                 position: 'fixed',
//                                                 top: 0,
//                                                 left: 0,
//                                                 width: '100%',
//                                                 height: '100%',
//                                                 backgroundColor: 'rgba(0,0,0,0.5)',
//                                                 display: 'flex',
//                                                 justifyContent: 'center',
//                                                 alignItems: 'center',
//                                                 zIndex: 1000,
//                                             }}
//                                         >
//                                             <div
//                                                 style={{
//                                                     backgroundColor: '#fff',
//                                                     borderRadius: '10px',
//                                                     padding: '30px',
//                                                     width: '90%',
//                                                     maxWidth: '463px',
//                                                     height: '630px',
//                                                     marginTop: "90px",
//                                                     boxShadow: '0 0 20px rgba(0,0,0,0.3)',
//                                                     position: 'relative',
//                                                 }}
//                                             >
//                                                 <button
//                                                     onClick={closePopup}
//                                                     style={{
//                                                         position: 'absolute',
//                                                         top: '10px',
//                                                         right: '15px',
//                                                         border: 'none',
//                                                         background: 'transparent',
//                                                         fontSize: '20px',
//                                                         cursor: 'pointer',
//                                                         fontWeight: 'bold',
//                                                         color: '#333',
//                                                     }}
//                                                 >
//                                                     ×
//                                                 </button>

//                                                 <h2 style={{ textAlign: 'center', fontFamily: 'Roboto', marginBottom: '20px', fontSize: '22px', fontWeight: 'bold' }}>
//                                                     Welcome to <span style={{ color: "blue" }}>International Institute of </span>
//                                                     <span style={{ color: "orange" }}>Automate</span>
//                                                 </h2>

//                                                 <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
//                                                     <input
//                                                         id="name"
//                                                         value={formData.name}
//                                                         onChange={handleChange}
//                                                         type="text"
//                                                         placeholder="Name"
//                                                         required
//                                                         style={inputStyle}
//                                                     />
//                                                     <input
//                                                         id="email"
//                                                         value={formData.email}
//                                                         onChange={handleChange}
//                                                         type="email"
//                                                         placeholder="Email"
//                                                         required
//                                                         style={inputStyle}
//                                                     />
//                                                     <input
//                                                         id="phone"
//                                                         value={formData.phone}
//                                                         onChange={handleChange}
//                                                         type="tel"
//                                                         placeholder="Phone"
//                                                         required
//                                                         style={inputStyle}
//                                                     />
//                                                     <input
//                                                         id="date"
//                                                         value={formData.date}
//                                                         onChange={handleChange}
//                                                         type="date"
//                                                         required
//                                                         style={inputStyle}
//                                                     />
//                                                     <select
//                                                         id="gender"
//                                                         value={formData.gender}
//                                                         onChange={handleChange}
//                                                         required
//                                                         style={{ ...inputStyle, cursor: "pointer" }}
//                                                     >
//                                                         <option value="">Select Gender</option>
//                                                         <option value="Male">Male</option>
//                                                         <option value="Female">Female</option>
//                                                         <option value="Other">Other</option>
//                                                     </select>
//                                                     <select
//                                                         id="cources"
//                                                         name="cources" // <-- This is important
//                                                         value={formData.cources}
//                                                         onChange={handleChange}
//                                                         required
//                                                         style={{ ...inputStyle, cursor: "pointer" }}
//                                                     >
//                                                         <option value="">Select courses</option>
//                                                         <option value="VirualRoboticsSimulation">Robotics Virtual Simulation</option>
//                                                         <option value="ToolandFixtureDesign">Tool & Fixture Design</option>
//                                                         <option value="DigitalFactorySolution">Digital Factory Solution</option>
//                                                         <option value="JavaFullStackDevelopers">Java Full Stack Developers</option>
//                                                         <option value="PythonFullStackDevelopers">Python Full Stack Developers</option>
//                                                         <option value="ReactJsAndFlutterDevelopers">React & Flutter Developers</option>
//                                                         <option value="CareerFoundationSkills">Career Foundation Skill</option>
//                                                         <option value="SoftSkillsEnhancement">Soft Skill</option>
//                                                         <option value="DigitalPresenceSkills">Digital Presence Skill</option>
//                                                     </select>

//                                                     <select
//                                                         id="plan"
//                                                         value={formData.plan}
//                                                         onChange={handleChange}
//                                                         required
//                                                         style={{ ...inputStyle, cursor: "pointer" }}
//                                                     >
//                                                         <option value="">Select plane</option>
//                                                         <option value="Industrial_Oriented_Training_Program">Industrial Oriented Training Program</option>
//                                                         <option value="Job_Oriented_Placement_Program">Job Oriented Placement Program</option>

//                                                     </select>
//                                                     <textarea
//                                                         id="message"
//                                                         value={formData.message}
//                                                         onChange={handleChange}
//                                                         placeholder="Message"
//                                                         rows="4"
//                                                         required
//                                                         style={{ ...inputStyle, resize: "vertical" }}
//                                                     />
//                                                     <button
//                                                         type="submit"
//                                                         style={{
//                                                             padding: "10px",
//                                                             fontSize: "14px",
//                                                             backgroundColor: "#007bff",
//                                                             color: "#fff",
//                                                             border: "none",
//                                                             borderRadius: "5px",
//                                                             fontWeight: "bold",
//                                                             cursor: "pointer",
//                                                             fontFamily: "Roboto",
//                                                         }}
//                                                     >
//                                                         Submit
//                                                     </button>
//                                                 </form>
//                                             </div>
//                                         </div>
//                                     )}
//                                     <style>
//                                         {`
//     @media (max-width: 768px) {
//       .disccccreting {
//         justify-content: center; /* Center-align items on smaller screens */
//         gap: 10px; /* Reduce gap for mobile view */
//       }

//       .disccccreting button {
//         flex: 1 0 100%; /* Make buttons full-width */
//         text-align: center; /* Center button text */
//       }

//       .disccccreting div {
//         flex: 1 0 100%; /* Ensure proper alignment for the rating section */
//         text-align: center; /* Center align rating */
//       }
//     }
//     `}
//                                     </style>
//                                 </div>
//                             </div>


//                         </div>

//                     </div>

//                     {/* Form and Video Section */}
//                     <div className="col-md-5 key-image" style={{ borderRadius: '20px', }}>
//                         {/* Video */}
//                         <div style={{ marginBottom: "20px" }}>
//                             <img className="key-image"
//                                 src={robotics}
//                                 alt="Robotics Preview"
//                                 style={{
//                                     width: "100%",
//                                     height: "301px",
//                                     borderRadius: "20px",
//                                     backgroundColor: "black",
//                                     objectFit: "cover",
//                                     boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
//                                 }}
//                             />
//                         </div>

//                     </div>


//                 </div>
//             </div>
//         </div>

//     );
// };

// export default KeyFuturesSection;




// import React, { useState } from "react";
// import { useNavigate } from 'react-router-dom';
// import robotics from "../img/aaaservices/robotics.jpg";

// const KeyFuturesSection = () => {
//     const navigate = useNavigate(); // useNavigate should be called inside the component

//     const goToEnquirySection = () => navigate('/contact#enquiry');
//     const goToHomeSection = () => navigate('/');
//     const goTofilterpage = () => navigate('/filterpage'); // no need to re-declare `useNavigate` inside this function

//     // Define handleFilter function
//     const handleFilter = (filterType) => {
//         // Navigate to homepage with a filter query or state
//         navigate('/Newallcardspage', { state: { filter: filterType } });
//     };

//     const [showPopup, setShowPopup] = useState(false);

//     const openPopup = () => setShowPopup(true);
//     const closePopup = () => setShowPopup(false);

//     const [formData, setFormData] = useState({
//         name: "",
//         email: "",
//         phone: "",
//         date: "",
//         gender: "",
//         message: "",
//         plan: "",
//         cources: "",
//     });

//     const handleChange = (e) => {
//         const { id, value } = e.target;
//         setFormData((prev) => ({
//             ...prev,
//             [id]: value,
//         }));
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         const apiBody = {
//             name: formData.name,
//             emailId: formData.email,
//             mobileNumber: formData.phone,
//             dateOfBirth: formData.date,
//             gender: formData.gender,
//             message: formData.message,
//             plan: formData.plan,
//             cources: formData.cources,
//         };

//         try {
//             const response = await fetch("http://iiaserver.iiautomate/IIA-Website-1.0.0/enquiry/add", {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json",
//                 },
//                 body: JSON.stringify(apiBody),
//             });

//             if (response.ok) {
//                 alert("Your details have been submitted successfully!");
//                 setFormData({
//                     name: "",
//                     email: "",
//                     phone: "",
//                     date: "",
//                     gender: "",
//                     message: "",
//                     plan: "",
//                     cources: "",
//                 });
//                 closePopup();
//             } else {
//                 alert("There was an issue submitting your details.");
//             }
//         } catch (error) {
//             alert("Something went wrong. Please try again later.");
//         }
//     };

//     const inputStyle = {
//         padding: "10px",
//         fontSize: "14px",
//         borderRadius: "5px",
//         border: "1px solid #ccc",
//         fontFamily: "Roboto",
//     };

//     return (
//         <div>
//             <div style={{
//                 position: 'fixed',
//                 top: '83px',
//                 width: '100%',
//                 backgroundColor: 'white',
//                 zIndex: '1000',
//                 padding: '10px 0',
//                 display: 'flex',
//                 justifyContent: 'center',
//                 gap: '10px'
//             }}>
//                 <button
//                     onClick={() => handleFilter('TecTalks')}
//                     style={{ width: '130px', height: '45px', backgroundColor: 'blue', color: 'white', border: 'none', borderRadius: '40px', fontWeight: 'bold' }}
//                 >
//                     TecTalks
//                 </button>
//                 <button
//                     onClick={() => handleFilter('Programs')}
//                     style={{ width: '130px', height: '45px', backgroundColor: 'blue', color: 'white', border: 'none', borderRadius: '40px', fontWeight: 'bold' }}
//                 >
//                     Programs
//                 </button>
//                 {/* <button
//                     onClick={() => handleFilter('jbs')}
//                     style={{ width: '130px', height: '45px', backgroundColor: 'blue', color: 'white', border: 'none', borderRadius: '40px', fontWeight: 'bold' }}
//                 >
//                     Jobs
//                 </button>
//                 <button
//                     onClick={() => handleFilter('WalkingDrive')}
//                     style={{ width: '130px', height: '45px', backgroundColor: 'blue', color: 'white', border: 'none', borderRadius: '40px', fontWeight: 'bold' }}
//                 >
//                     WalkingDrive
//                 </button> */}
//             </div>
//             <div>
//                 <div className="webinarsss" style={{ fontSize: '30px', color: 'black', fontFamily: 'Roboto', fontWeight: 'bold', margTop: '50px', textAlign: 'center', marginTop: '20px' }}>
//                     Robotics & <span style={{ color: 'blue' }}>Virtual Simulation</span>
//                 </div>
//                 <div className="container mt-5">
//                     <div className="row d-flex align-items-start" style={{ marginTop: "90px" }}>
//                         {/* Content Section */}
//                         <div className="col-md-7">
//                             <div className="p-4 bg-white shadow rounded mb-4 virtual-key" style={{ height: '300px' }}>
//                                 <h2 style={{ fontWeight: "bold", fontSize: '22px', fontFamily: 'roboto' }}>
//                                     {" "}
//                                     <span style={{ color: 'blue' }}> 6-Axis </span> Industrial Robotic Virtual <span style={{ color: 'orange' }}> Simulation </span>{" "}
//                                 </h2>
//                                 <div style={{ textAlign: 'justify', fontFamily: 'roboto' }}>
//                                     <p style={{ fontFamily: 'roboto' }}>
//                                         Adoption of 6-axis industrial robots is revolutionizing sectors such as manufacturing and logistics, offering precise automation for tasks like welding and assembly. Virtual simulation allows for cost-effective testing and optimization without physical hardware, reducing risks and costs. As the demand for automation grows, and with advancements in AI and IoT, mastering robotic programming and simulation is crucial for staying ahead in this dynamic field.
//                                     </p>
//                                     <div className="disccccreting" style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', gap: '20px', marginTop: '19px', flexWrap: 'wrap' }}>
//                                         <div style={{ display: 'flex', alignItems: 'center', gap: '5px', flex: '1 1 auto' }}>
//                                             <span style={{ fontSize: '16px', fontWeight: 'bold' }}>4.5</span>
//                                             <div style={{ display: 'flex', fontSize: '20px', flex: '1 1 auto' }}>
//                                                 <span style={{ color: '#FFD700' }}>★</span>
//                                                 <span style={{ color: '#FFD700' }}>★</span>
//                                                 <span style={{ color: '#FFD700' }}>★</span>
//                                                 <span style={{ color: '#FFD700' }}>★</span>
//                                                 <span style={{ color: '#FFD700', position: 'relative' }}>
//                                                     <span style={{ color: '#fff', position: 'absolute', left: '8px', overflow: 'hidden', width: '10px' }}>★</span>
//                                                 </span>
//                                             </div>
//                                             <div style={{ display: 'flex', gap: '10px', flex: '1 1 auto', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
//                                                 <a href="/brochure.pdf" download="brochure.pdf" style={{ textDecoration: 'none', display: 'inline-block' }}>
//                                                     <button style={{ padding: '10px 20px', fontSize: '14px', backgroundColor: '#007bff', color: 'white', border: '1px solid #ccc', borderRadius: '5px', fontFamily: 'roboto', fontWeight: 'bold', cursor: 'pointer', flex: '1 1 auto', minWidth: '120px' }}>Brochure</button>
//                                                 </a>


//                                                 <button onClick={goTofilterpage} style={{ padding: '10px 20px', fontSize: '14px', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '5px', fontFamily: 'roboto', fontWeight: 'bold', cursor: 'pointer', flex: '1 1 auto', minWidth: '120px' }}>Bokk Now</button>



//                                                 <button onClick={goToEnquirySection} style={{ padding: '10px 20px', fontSize: '14px', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '5px', fontFamily: 'roboto', fontWeight: 'bold', cursor: 'pointer', flex: '1 1 auto', minWidth: '120px' }}>Enquiry Now</button>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>

//                         {/* Form and Video Section */}
//                         <div className="col-md-5 key-image" style={{ borderRadius: '20px' }}>
//                             <div style={{ marginBottom: "20px" }}>
//                                 <img className="key-image" src={robotics} alt="Robotics Preview" style={{ width: "100%", height: "301px", borderRadius: "20px", backgroundColor: "black", objectFit: "cover", boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)" }} />
//                             </div>
//                         </div>

//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default KeyFuturesSection;





import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import robotics from "../img/aaaservices/robotics.jpg";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart } from '@fortawesome/free-solid-svg-icons';

import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

import jsPDF from "jspdf";
const KeyFuturesSection = () => {
    const navigate = useNavigate();
    const goToEnquirySection = () => navigate('/contact#enquiry');
    const handleFilter = (filterType) => {
        navigate('/Newallcardspage', { state: { filter: filterType } });
    };
 const goToSecondactiveprogramsSection = () => navigate('/Secondactiveprograms');
   

    const [showPopup, setShowPopup] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [loading, setLoading] = useState(false);


    const openPopup = () => {
        setShowPopup(true);
        setSubmitted(false);
        setEmail('');
        setPhone('');
    };

    const closePopup = () => {
        setShowPopup(false);
    };

    const [courseDetails] = useState({
        name: 'Robotics Virtual Simulation',
        description: 'Learn robotics using interactive virtual simulation tools.',
        fee: '₹3,999',
    });



    const [emailError, setEmailError] = useState('');
    const [phoneError, setPhoneError] = useState('');

    const [phoneCode, setPhoneCode] = useState('+91'); // default to India
const [phoneNumber, setPhoneNumber] = useState('');

    const validate = () => {
        let valid = true;

        // Email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            setEmailError('Please enter a valid email.');
            valid = false;
        } else {
            setEmailError('');
        }

        // Phone validation (accepts country code + digits, but limits digit part to 10)
        const phoneDigits = phone.replace(/\D/g, '');
        if (phoneDigits.length > 10) {
            setPhoneError('Phone number should not exceed 10 digits (excluding country code).');
            valid = false;
        } else {
            setPhoneError('');
        }

        return valid;
    };

    const handleSubmit = () => {
        if (validate()) {
            setSubmitted(true);
            console.log('Form submitted');
        }
    };




    const styles = {
        overlayBg: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 999,
        },
        popup: {
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: '#fff',
            padding: '20px',
            borderRadius: '10px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
            zIndex: 1000,
            width: '90%',
            maxWidth: '400px',
        },
        bookBtn: {
            marginTop: '10px',
            padding: '10px 20px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            fontWeight: 'bold',
            width: '100%',
            cursor: 'pointer',
        }
    };



    const generatePDF = () => {


        const doc = new jsPDF();

        // Blue header bar
        doc.setFillColor(52, 152, 219); // blue color
        doc.rect(0, 10, 210, 15, 'F');

        // Main Heading (white text on blue)
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(16);
        doc.setFont("helvetica", "bold");
        doc.text("International Institute of Automation", 10, 20);

        // Sub-heading (course name) under main heading
        doc.setFontSize(12);
        doc.text("Course Name: Robotics Virtual Simulation", 10, 28);

        // Reset color for rest of the text (black)
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");

        // Company address - example, you can customize
        doc.text("1912 Harvest Lane", 10, 40);
        doc.text("New York, NY 12210", 10, 46);

        // Bill To, Ship To and Invoice Details - sample layout
        doc.setFont("helvetica", "bold");
        doc.text("Bill To", 10, 60);
        doc.text("Ship To", 70, 60);
        doc.text("Invoice #", 140, 60);

        doc.setFont("helvetica", "normal");
        doc.text("John Smith", 10, 66);
        doc.text("2 Court Square", 10, 72);
        doc.text("New York, NY 12210", 10, 78);

        doc.text("John Smith", 70, 66);
        doc.text("3787 Pineview Drive", 70, 72);
        doc.text("Cambridge, MA 12210", 70, 78);

        doc.text("US-001", 140, 66);
        doc.text("Invoice Date: 11/02/2019", 140, 72);
        doc.text("P.O.# 2312/2019", 140, 78);
        doc.text("Due Date: 26/02/2019", 140, 84);

        // Draw table headers background
        doc.setFillColor(240, 240, 240);
        doc.rect(10, 90, 190, 10, 'F');

        // Table Headers
        doc.setTextColor(0, 0, 0);
        doc.setFont("helvetica", "bold");
        doc.text("QTY", 15, 97);
        doc.text("DESCRIPTION", 40, 97);
        doc.text("UNIT PRICE", 140, 97, { align: "right" });
        doc.text("AMOUNT", 190, 97, { align: "right" });

        // Table rows
        doc.setFont("helvetica", "normal");
        const items = [
            { qty: 1, desc: "Front and rear brake cables", unitPrice: 100.00, amount: 100.00 },
            { qty: 2, desc: "New set of pedal arms", unitPrice: 15.00, amount: 30.00 },
            { qty: 3, desc: "Labor 3hrs", unitPrice: 5.00, amount: 15.00 },
        ];

        let y = 105;
        items.forEach(item => {
            doc.text(String(item.qty), 15, y);
            doc.text(item.desc, 40, y);
            doc.text(item.unitPrice.toFixed(2), 140, y, { align: "right" });
            doc.text(item.amount.toFixed(2), 190, y, { align: "right" });
            y += 10;
        });

        // Subtotal and taxes
        doc.text("Subtotal", 140, y + 5, { align: "right" });
        doc.text("145.00", 190, y + 5, { align: "right" });

        doc.text("Sales Tax 6.25%", 140, y + 12, { align: "right" });
        doc.text("9.06", 190, y + 12, { align: "right" });

        doc.setFont("helvetica", "bold");
        doc.text("TOTAL", 140, y + 20, { align: "right" });
        doc.text("$154.06", 190, y + 20, { align: "right" });

        // Signature image placeholder - you can replace this with actual image with doc.addImage()
        doc.setFont("helvetica", "normal");
        doc.text("John Smith", 140, y + 45);

        // Footer text
        doc.setFontSize(8);
        doc.text("Terms & Conditions", 10, y + 60);
        doc.text("Payment is due within 15 days.", 10, y + 65);
        doc.text("Please make checks payable to: East Repair Inc.", 10, y + 70);

        // Save the PDF
        doc.save("custom_invoice.pdf");
    };


    const initiatePayment = async () => {
        setLoading(true);

        // Payment and transaction details

        // Razorpay Payment Options for paid courses
        var options = {
            key: "rzp_test_oqm83qg9Z710lA",
            key_secret: "eaHmzOnTh2AqXLFRFWavB29c",
            amount: 1 * 100, // Convert price to paise
            currency: "INR",
            payment_capture: true,
            name: "International Institute Of Automate",
            handler: async function (response) {
                alert(
                    "Thanks For Your Interest \n Your Payment has been successfully completed"
                );
                generatePDF();
                // Call API to update payment status

            },
            notes: {
                address: "International Institute Of Automate",
            },
            theme: {
                color: "#3399cc",
            },
        };

        var pay = new window.Razorpay(options);
        pay.open();
    }

    return (
        <div>
            {/* Fixed Filter Buttons */}
            <div style={{
                position: 'fixed',
                top: '83px',
                width: '100%',
                backgroundColor: 'white',
                zIndex: '1000',
                padding: '10px 0',
                display: 'flex',
                justifyContent: 'center',
                gap: '10px'
            }}>
                <button
                    onClick={() => handleFilter('TecTalks')}
                    style={{ width: '130px', height: '45px', backgroundColor: 'blue', color: 'white', border: 'none', borderRadius: '40px', fontWeight: 'bold' }}
                >
                    TecTalks
                </button>
                <button
                    onClick={() => goToSecondactiveprogramsSection('Programs')}
                    style={{ width: '130px', height: '45px', backgroundColor: 'orange', color: 'white', border: 'none', borderRadius: '40px', fontWeight: 'bold' }}
                >
                    Programs
                </button>
            </div>

            {/* Title */}
            <div className="webinarsss" style={{ fontSize: '30px', color: 'black', fontFamily: 'Roboto', fontWeight: 'bold', textAlign: 'center', marginTop: '158px' }}>
                Robotics & <span style={{ color: 'blue' }}>Virtual Simulation</span>
            </div>

            <div className="container mt-5">
                <div className="row d-flex align-items-start" style={{ marginTop: "30px" }}>
                    {/* Content Section */}
                    <div className="col-md-7">
                        <div className="p-4 bg-white shadow rounded mb-4 virtual-key" style={{ height: 'auto' }}>
                            <h2 style={{ fontWeight: "bold", fontSize: '22px', fontFamily: 'roboto' }}>
                                <span style={{ color: 'blue' }}>6-Axis</span> Industrial Robotic Virtual <span style={{ color: 'orange' }}>Simulation</span>
                            </h2>
                            <p style={{ textAlign: 'justify', fontFamily: 'roboto' }}>
                                Adoption of 6-axis industrial robots is revolutionizing sectors such as manufacturing and logistics, offering precise automation for tasks like welding and assembly. Virtual simulation allows for cost-effective testing and optimization without physical hardware, reducing risks and costs. As the demand for automation grows, and with advancements in AI and IoT, mastering robotic programming and simulation is crucial for staying ahead in this dynamic field.
                            </p>

                            <div className="disccccreting" style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', gap: '20px', marginTop: '19px', flexWrap: 'wrap' }}>



                                <span style={{ fontSize: '16px', fontWeight: 'bold' }}>4.5</span>
                                <div style={{ display: 'flex', fontSize: '20px', flex: '1 1 auto' }}>
                                    <span style={{ color: '#FFD700' }}>★</span>
                                    <span style={{ color: '#FFD700' }}>★</span>
                                    <span style={{ color: '#FFD700' }}>★</span>
                                    <span style={{ color: '#FFD700' }}>★</span>
                                    <span style={{ color: '#FFD700', position: 'relative' }}>                                                     <span style={{ color: '#fff', position: 'absolute', left: '8px', overflow: 'hidden', width: '10px' }}>★</span>                                                 </span>
                                </div>



                                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginTop: '20px' }}>
                                    <a href="/brochure.pdf" download="brochure.pdf" style={{ textDecoration: 'none' }}>
                                        <button style={{ padding: '10px 20px', fontSize: '14px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '5px', fontWeight: 'bold' }}>
                                            Brochure
                                        </button>
                                    </a>
                                    <button
                                        onClick={openPopup}
                                        style={{
                                            padding: '10px 20px',
                                            fontSize: '14px',
                                            backgroundColor: '#007bff',
                                            color: '#fff',
                                            border: 'none',
                                            borderRadius: '5px',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        Book Now
                                    </button>

                                    <button onClick={goToEnquirySection} style={{ padding: '10px 20px', fontSize: '14px', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '5px', fontFamily: 'roboto', fontWeight: 'bold', cursor: 'pointer', minWidth: '120px' }}>Enquiry Now</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Image Section */}
                    <div className="col-md-5">
                        <img src={robotics} alt="Robotics" style={{ width: '100%', borderRadius: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.2)', height: '282px' }} />
                    </div>
                </div>
            </div>

            {/* Popup Form */}
            {showPopup && (
                <>
                    <div style={styles.overlayBg} onClick={closePopup} />
                    <div style={styles.popup}>
                        {!submitted ? (
                            <>
                                
                                <div style={{ maxWidth: '320px', padding: '10px' }}>
                                    <h3 style={{ color: 'blue', fontSize: '20px' }}>Enter Your Details</h3>

                                    <input
                                        type="email"
                                        placeholder="Email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        style={{ width: '100%', padding: '8px', margin: '5px 0' }}
                                    />
                                    {emailError && <div style={{ color: 'red', fontSize: '14px' }}>{emailError}</div>}

                                    <div style={{ display: 'flex', marginTop: '10px' }}>
                                        <select
                                            value={phoneCode}
                                            onChange={(e) => setPhoneCode(e.target.value)}
                                            style={{
                                                padding: '8px',
                                                border: '1px solid #ccc',
                                                borderRadius: '4px 0 0 4px',
                                                backgroundColor: '#fff'
                                            }}
                                        >
                                            <option value="+91">+91 (IN)</option>
                                            <option value="+1">+1 (US)</option>
                                            <option value="+44">+44 (UK)</option>
                                            <option value="+61">+61 (AU)</option>
                                            {/* Add more if needed */}
                                        </select>
                                        <input
                                            type="tel"
                                            placeholder="Phone number"
                                            value={phoneNumber}
                                            onChange={(e) => setPhoneNumber(e.target.value.replace(/\D/, ''))}
                                            style={{
                                                width: '100%',
                                                padding: '8px',
                                                border: '1px solid #ccc',
                                                borderLeft: 'none',
                                                borderRadius: '0 4px 4px 0'
                                            }}
                                        />
                                    </div>
                                    {phoneError && <div style={{ color: 'red', fontSize: '14px' }}>{phoneError}</div>}

                                    <button
                                        onClick={handleSubmit}
                                        style={{
                                            backgroundColor: 'orange',
                                            color: 'white',
                                            padding: '10px 20px',
                                            border: 'none',
                                            borderRadius: '5px',
                                            marginTop: '10px',
                                            cursor: 'pointer',
                                            width: '100%'
                                        }}
                                    >
                                        Proceed to Pay
                                    </button>
                                </div>
                            </>
                        ) : (
                            <>
                                <h3 style={{ color: 'green', fontSize: '20px' }}></h3>
                                <p style={{ fontFamily: 'math', color: 'blue' }}>Email: {email}</p>
                                <p style={{ fontFamily: 'math', color: 'blue' }}>Phone: {phone}</p>
                                <p style={{ fontFamily: 'math', color: 'black' }}>Course: {courseDetails.name}</p>
                                <p style={{ fontFamily: 'math', color: 'black' }}>Course: {courseDetails.description}</p>
                                <p style={{ fontFamily: 'math', color: 'blue' }}>Course: {courseDetails.fee}</p>


                                <button
                                    style={styles.bookBtn} onClick={initiatePayment} disabled={loading}>
                                    {loading ? 'Processing...' : 'Pay Now'}
                                </button>
                            </>
                        )}
                    </div>
                </>
            )}
        </div>
    );
};

export default KeyFuturesSection;



